// Landing.tsx — the one-page site. Assembles the five sections, then starts
// the scroll choreography (the mint-nest / closing-cube settle-ins) and the
// mint handoff (the mint cube's flight from the mark into the Latently room).
//
// .mint-flyer is the last child on purpose: it is the mint-handoff beat's
// only piece of DOM (src/motion/mintHandoff.ts moves it, never creates it),
// absolutely positioned against .landing (position: relative below), and
// hidden by default in Landing.css — no JS means no flyer ever shows.
import { useEffect, useRef } from 'react';
import { Hero } from './sections/Hero';
import { Assembly } from './sections/Assembly';
import { MeetLatently } from './sections/MeetLatently';
import { HowWeWork } from './sections/HowWeWork';
import { Closing } from './sections/Closing';
import { CubeGlyph } from './marks/CubeGlyph';
import { CubeSpawn } from './CubeSpawn';
import { initMarkChoreography } from '../motion/markChoreography';
import { initMintHandoff } from '../motion/mintHandoff';
import './Landing.css';

const Landing = () => {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const stopChoreography = initMarkChoreography(rootRef.current!);
    const stopMintHandoff = initMintHandoff(rootRef.current!);
    return () => {
      stopChoreography();
      stopMintHandoff();
    };
  }, []);

  return (
    <div className="landing" ref={rootRef}>
      <CubeSpawn />
      <Hero />
      <Assembly />
      <MeetLatently />
      <HowWeWork />
      <Closing />
      <div className="mint-flyer" aria-hidden="true" data-mark="mint-flyer">
        <CubeGlyph tone="mint" size={48} />
      </div>
    </div>
  );
};

export default Landing;
